import Vue from 'vue'

export default {
  /*
   * index() lista los operadores
   */
  index(params, skipLoading = false) {
    return Vue.http.get('mobile_app/v1/entity/operators/list', {params, skipLoading}).then(response => response.data)
  }
}
